import "./footer.css";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneCallbackIcon from "@mui/icons-material/PhoneCallback";
import FacebookIcon from "@mui/icons-material/Facebook";
import Instagram from "@mui/icons-material/Instagram";
import MusicNoteIcon from "@mui/icons-material/MusicNote";

export const Footer = () => {
  return (
    <footer className="footerWrapper" id="kontakt">
      <div className="footerInner">
        <div className="footerSection">
          <h3 className="footerHeading">Kontakt</h3>
          <address className="footerAddress">
            <div className="footerRow">
              <LocationOnIcon className="mui" aria-hidden="true" />
              <div className="location">
                <span className="name">CJ´s BARBERSHOP</span>
                <span>Špindlerova třída 687</span>
                <span>Roudnice nad Labem</span>
              </div>
            </div>
            <div className="footerRow">
              <PhoneCallbackIcon className="mui" aria-hidden="true" />
              <a href="tel:+420777606447" className="footerLink">
                +420 777 606 447
              </a>
            </div>
          </address>
        </div>

        <div className="footerSection">
          <h3 className="footerHeading">Sledujte nás</h3>
          <div className="footerSocials" aria-label="Sociální sítě">
            <a
              href="https://www.instagram.com/cj.s_barbershop"
              className="footerSocialLink"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <Instagram className="mui" aria-hidden="true" />
              <span>Instagram</span>
            </a>
            <a
              href="https://www.facebook.com/people/CJs-Barbershop/100085528367093/"
              className="footerSocialLink"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FacebookIcon className="mui" aria-hidden="true" />
              <span>Facebook</span>
            </a>
            <a
              href="https://www.tiktok.com/@cj_s_barbershop"
              className="footerSocialLink"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok"
            >
              <MusicNoteIcon className="mui" aria-hidden="true" />
              <span>TikTok</span>
            </a>
          </div>
        </div>
      </div>

      <div className="footerBottom">
        <span>&copy; {new Date().getFullYear()} CJ´s Barbershop. Všechna práva vyhrazena.</span>
      </div>
    </footer>
  );
};
